<template>
  <div class="page-wrapper">
    <div class="page-head">
      <div class="logo">
        <img v-if="currentPage === 1" src="@/assets/images/result/logo_sen_ko.png" alt="메인 로고" />
        <img v-else src="@/assets/images/result/logo_sen_eng.png" alt="서브 로고" />
      </div>      
      <div class="date">
        <template v-if="currentPage === 1">
            <span>검사시행</span>
            <p>{{ FIXED_DATE }}</p>
        </template>        
        <template v-else>
            <span>서울 학생 AI·디지털 리터러시 진단검사</span>
            <p>{{ subTitle || '' }}</p>
        </template>
        </div>
    </div>

    <div class="page-inner">
      <slot></slot>       
    </div>
    <PageFooter :current-page="currentPage" :total-pages="totalPages" />
  </div>
</template>

<script setup>
import PageFooter from '@/components/result/PageFooter.vue';

const props = defineProps({
  currentPage: Number,
  totalPages: Number,
  subTitle: String
});

const FIXED_DATE = "2025년 12월";

</script>

<style lang="scss" scoped>
.page-wrapper { 
  background: linear-gradient(34.65deg, rgba(255, 255, 255, 0) 60.7%, rgba(36, 124, 255, 0.2) 88.73%), linear-gradient(203.69deg, #EBF7FF 4.72%, #B2EAFF 94.9%);
  padding: 0 1.25rem 0;
  .page-head {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    height: 6.25rem;
    padding: 1.5rem 1.25rem;
    .date {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 2px 0 2px 0.375rem;
        gap: .25rem;
        border-left: 4px solid var(--result-ai-primary-500); 
        span { color: var(--result-ai-primary-800); font-size: .938rem; font-weight: 800;}
    }
  }
  .page-inner { background-color: #fff; border-radius: .625rem; min-height: 500px; }
  :deep(.result-footer) {
    background-color: transparent !important;     
    padding: .938rem 0; 
    .footer-content { justify-content: flex-end !important; }
  } 
}
</style>